import {enumOf} from "@rezonence/enum-generator";
import {DatasetItem} from "./dataset.item";
import { keys } from "ts-transformer-keys";

export type DatasetItemKey = DatasetItem<any>[keyof DatasetItem<any>];

export const DatasetItemKey = enumOf(keys<DatasetItem<any>>());